import { TextInput, TextInputProps, Textarea, TextareaProps } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import styles from "./TextBox.module.scss";

// Shared wiring: bind the field to a Mantine form by name. Everything else
// (label, placeholder, description, error, disabled, …) passes straight through
// to the underlying Mantine input.
interface FieldProps {
    formInstance: UseFormReturnType<any>;
    name: string;
}

/** Single-line text field bound to a Mantine form. */
export const TextBox = ({ formInstance, name, ...props }: FieldProps & Omit<TextInputProps, "name">) => (
    <TextInput
        {...formInstance.getInputProps(name)}
        {...props}
        classNames={{ root: styles.root, input: styles.input }}
    />
);

interface TextAreaProps extends FieldProps, Omit<TextareaProps, "name"> {
    /** Field height — a number (px) or any CSS length. Defaults to 8rem. */
    height?: number | string;
}

/** Multi-line text field bound to a Mantine form. Set `height` to resize it. */
export const TextArea = ({ formInstance, name, height = "8rem", ...props }: TextAreaProps) => (
    <Textarea
        {...formInstance.getInputProps(name)}
        {...props}
        classNames={{ root: styles.root, input: styles.input }}
        styles={{ input: { height, minHeight: height } }}
    />
);
